import React, { Component } from 'react';
import { connect } from 'react-redux';
import pluralize from 'pluralize';
import PropTypes from 'prop-types';

import { H2 } from '@studio/legacy-components';

import { read as fetchAccountEntitlements } from 'actions/entitlements';
import { ENTITLEMENTS } from 'constants/features';
import { ENTITLEMENTS_CAPTIONS } from 'constants/entitlements';
import {
  EntitlementsWrapper,
  SubscriptionCardWrapper,
} from 'components/Subscription/styled';
import { selectAccountFeature } from 'reducers/account/features';
import { Entitlement as EntitlementShape } from 'components/Subscription/shape';
import { numberWithCommas } from 'utils/textFormatting';

import InstallationIssues from './InstallationIssues';
import EntitlementProgress from './EntitlementProgress';

export class CurrentPeriod extends Component {
  componentDidMount() {
    const { onLoad } = this.props;

    onLoad();
  }

  render() {
    const {
      anonymousMaus,
      entitlementsProcessed,
      hasEntitlements,
      mausProcessed,
      monthlyActiveUsers,
    } = this.props;

    const entitlements = hasEntitlements
      ? [mausProcessed, ...entitlementsProcessed]
      : [mausProcessed];

    const overallAnonymousPercent = Math.round(
      (anonymousMaus / monthlyActiveUsers) * 100,
      2
    );

    return (
      <SubscriptionCardWrapper kind="borderless">
        <H2 type="secondary">Your usage</H2>

        <EntitlementsWrapper>
          {entitlements.map(
            ({
              availableUnits,
              completePercent,
              currentStatus,
              id,
              showWarning,
              usedUnits,
            }) => (
              <>
                <EntitlementProgress
                  key={id}
                  title={`${numberWithCommas(usedUnits)} of ${numberWithCommas(
                    availableUnits
                  )}`}
                  caption={
                    id === 'maus'
                      ? ENTITLEMENTS_CAPTIONS[id]
                      : pluralize(ENTITLEMENTS_CAPTIONS[id])
                  }
                  completePercent={completePercent}
                  currentStatus={currentStatus}
                  showWarning={showWarning}
                />
                {id === 'maus' && overallAnonymousPercent > 0 && (
                  <InstallationIssues
                    key={`issues-${id}`}
                    overallAnonymousPercent={overallAnonymousPercent}
                    overallIdentifiedPercent={100 - overallAnonymousPercent}
                  />
                )}
              </>
            )
          )}
        </EntitlementsWrapper>
      </SubscriptionCardWrapper>
    );
  }
}

CurrentPeriod.propTypes = {
  anonymousMaus: PropTypes.number,
  entitlementsProcessed: PropTypes.arrayOf(EntitlementShape),
  hasEntitlements: PropTypes.bool,
  onLoad: PropTypes.func,
  mausProcessed: EntitlementShape,
  monthlyActiveUsers: PropTypes.number,
};

const mapStateToProps = state => {
  return {
    hasEntitlements: selectAccountFeature(state, ENTITLEMENTS),
  };
};

const mapDispatchToProps = {
  onLoad: fetchAccountEntitlements,
};

export default connect(mapStateToProps, mapDispatchToProps)(CurrentPeriod);
